import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import FontHeading4 from '../../../../../../components/fonts/font-heading4/font-heading4';
import FontHeading5 from '../../../../../../components/fonts/font-heading5/font-heading5';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../components/fonts/font-props';
import { Badge, BadgeType } from '../../../../../../components/badge/badge';

import { OrderEligibility } from '../order-eligibility-display.service';

interface OrderStatusBannerProps {
    orderEligibility?: OrderEligibility;
    hasEligibleItems: boolean;
    orderName?: string;
}

const OrderStatusBanner: React.FC<OrderStatusBannerProps> = ({ 
    orderEligibility, 
    hasEligibleItems, 
    orderName 
}) => {
    // Add defensive programming to prevent runtime errors
    if (!orderEligibility) {
        return (
            <div className="order-status-banner">
                <div className="banner-content">
                    <div className="banner-title">
                        {orderName && (
                            <div className="order-title-inline">
                                <FontHeading5 color={FONT_COLOR.NEUTRAL10} variant={[FONT_VARIANT.DEFAULT]}>
                                    Order:
                                </FontHeading5>
                                <FontHeading4 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                                    {orderName}
                                </FontHeading4>
                            </div>
                        )}
                    </div>
                    <div className="banner-badge">
                        <Badge type={BadgeType.WARNING} text="Loading..." />
                    </div>
                </div>
            </div>
        );
    }

    const isRmaBlocked = orderEligibility.create_rma_not_allowed === true;
    
    let bannerType = BadgeType.SUCCESS;
    let bannerText = 'Order Eligible';
    
    if (isRmaBlocked) {
        bannerType = BadgeType.WARNING;
        bannerText = 'RMA Creation Blocked';
    } else if (!hasEligibleItems) {
        bannerType = BadgeType.WARNING;
        bannerText = 'No Eligible Items';
    }
    
    return (
        <div className={`order-status-banner ${bannerType === BadgeType.WARNING ? 'warning' : ''}`}>
            <div className="banner-content">
                <div className="banner-title">
                    {orderName && (
                        <div className="order-title-inline">
                            <FontHeading5 color={FONT_COLOR.NEUTRAL10} variant={[FONT_VARIANT.DEFAULT]}>
                                Order:
                            </FontHeading5>
                            <FontHeading4 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                                {orderName}
                            </FontHeading4>
                        </div>
                    )}
                    {isRmaBlocked && orderEligibility.create_rma_not_allowed_reason && (
                        <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER}>
                            - {typeof orderEligibility.create_rma_not_allowed_reason === 'string' 
                                ? orderEligibility.create_rma_not_allowed_reason 
                                : JSON.stringify(orderEligibility.create_rma_not_allowed_reason)}
                        </FontBody2>
                    )}
                </div>
                <div className="banner-badge">
                    <Badge type={bannerType} text={bannerText} />
                </div>
            </div>
        </div>
    );
};

export default OrderStatusBanner;
